import { render } from "./anc_investigations.vue?vue&type=template&id=2f96ad3c&scoped=true"
import script from "./anc_investigations.vue?vue&type=script&lang=js"
export * from "./anc_investigations.vue?vue&type=script&lang=js"

import "./anc_investigations.vue?vue&type=style&index=0&id=2f96ad3c&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f96ad3c"]])

export default __exports__